import { useState, useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { useSelector } from 'react-redux';
import {
  getOrCreateSupportChatRoomV2,
  listChatRoomsByGuest,
} from '../../graphql/messaging';

const useCreateSupportChatRoom = () => {
  const [loading, setLoading] = useState(false);
  const [getOrCreateSupportChatRoom] = useMutation(getOrCreateSupportChatRoomV2);
  const userId = useSelector((state) => state?.auth?.user?.id || state?.auth?.user?._id);

  const openSupportChat = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getOrCreateSupportChatRoom({
        ...(userId ? {
          refetchQueries: [{
            query: listChatRoomsByGuest,
            variables: { guestID: userId, limit: 100 },
          }],
        } : {}),
      });
      const chatRoom = result?.data?.getOrCreateSupportChatRoom;
      if (!chatRoom) throw new Error('Support-Chat konnte nicht erstellt werden');
      return chatRoom;
    } finally {
      setLoading(false);
    }
  }, [getOrCreateSupportChatRoom, userId]);

  return { openSupportChat, loading };
};

export default useCreateSupportChatRoom;
